import styled from 'styled-components';

import { H3 } from 'components/Text/H3';

export const ListingPageSectionTitle = styled(H3)`
  margin-bottom: 24px;
`;
